import React, { useEffect, useState } from "react";
import { fetchTestimonials } from "@/lib/api";
import { Quote, ChevronLeft, ChevronRight, Star } from "lucide-react";

export default function Testimonials() {
    const [items, setItems] = useState([]);
    const [idx, setIdx] = useState(0);

    useEffect(() => {
        fetchTestimonials().then(setItems).catch(() => setItems([]));
    }, []);

    if (!items.length) return null;

    const current = items[idx];
    const prev = () => setIdx((idx - 1 + items.length) % items.length);
    const next = () => setIdx((idx + 1) % items.length);

    return (
        <section id="testimonials" className="section relative" data-testid="testimonials-section">
            <div className="container-x">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
                    <div className="lg:col-span-4">
                        <div className="flex items-center gap-3 mb-6">
                            <span className="h-px w-10 bg-[#C8A064]" />
                            <span className="overline">Voices</span>
                        </div>
                        <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl text-[#F3F4F6] leading-tight">
                            Trusted by traders <em className="text-[#C8A064] not-italic">who don't trust easily.</em>
                        </h2>
                        <div className="mt-10 flex items-center gap-3">
                            <button
                                onClick={prev}
                                className="w-12 h-12 border border-[#C8A064]/40 text-[#C8A064] hover:bg-[#C8A064] hover:text-[#0A1547] transition-colors flex items-center justify-center"
                                data-testid="testimonial-prev"
                                aria-label="Previous"
                            >
                                <ChevronLeft size={16} />
                            </button>
                            <button
                                onClick={next}
                                className="w-12 h-12 border border-[#C8A064]/40 text-[#C8A064] hover:bg-[#C8A064] hover:text-[#0A1547] transition-colors flex items-center justify-center"
                                data-testid="testimonial-next"
                                aria-label="Next"
                            >
                                <ChevronRight size={16} />
                            </button>
                        </div>
                    </div>

                    <div className="lg:col-span-8">
                        <article
                            key={current.id}
                            className="card-glass p-10 md:p-14 relative rise-in"
                            data-testid="testimonial-card"
                        >
                            <Quote
                                size={48}
                                strokeWidth={1.2}
                                className="text-[#C8A064]/30 absolute top-6 right-8"
                            />
                            <div className="flex gap-1 mb-6">
                                {[...Array(current.rating || 5)].map((_, i) => (
                                    <Star key={i} size={14} className="fill-[#C8A064] text-[#C8A064]" />
                                ))}
                            </div>
                            <p className="font-serif-display text-2xl md:text-3xl text-[#F3F4F6] leading-snug">
                                "{current.quote}"
                            </p>
                            <div className="mt-10 pt-6 border-t border-white/10">
                                <div className="font-serif-display text-lg text-[#C8A064]">
                                    {current.name}
                                </div>
                                <div className="text-sm text-[#94A3B8]">{current.role}</div>
                            </div>
                        </article>
                    </div>
                </div>
            </div>
        </section>
    );
}
